import { Container, Box, Typography, Divider } from '@mui/material';
import PropTypes from 'prop-types';

import { Paper } from '../default/papers/Paper';
import { heroDarkImage } from '../../assets';

/**
 * Componente genérico para renderizar painéis de autenticação.
 *
 * @param {string} title - Título do painel (ex: Login, Cadastro, etc)
 * @param {JSX.Element} form - Formulário do painel
 * @param {JSX.Element} footer - Links ou mensagens abaixo do formulário
 * @returns {JSX.Element}
 */

const AuthCard = ({ title, form, footer }) => {
    return (
        <Container component="main" maxWidth="sm"
            sx={{
                height: '100vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
            <Paper>
                <Box display="flex" flexDirection="column" alignItems="center" gap={1}>
                    <Box display="flex" alignItems="center" gap={1} marginBottom={2}>
                        <img src={heroDarkImage} alt="4kst" height={32} />
                    </Box>
                    <Typography variant="h5" textAlign="center">
                        {title}
                    </Typography>
                </Box>
                <Divider style={{ width: '100%' }} />
                {form}
                {footer}
            </Paper>
        </Container>
    );
};

AuthCard.propTypes = {
    title: PropTypes.string.isRequired,
    form: PropTypes.element.isRequired,
    footer: PropTypes.element,
    withAvatar: PropTypes.bool,
    logo: PropTypes.element
};

export default AuthCard;
